import React from "react";
import siteConfig from "../Datas/siteConfig";
import "../css/privacy.scss";

function Cookies() {
  return <main className="policy-page content-page">
    <p className="eyebrow">POLICIES</p>
    <h1>Cookie policy</h1>
    <p className="policy-date">Effective date: 24 September 2026</p>
    <section>
      <h2>How this website stores information</h2>
      <p>This policy explains the cookies and browser storage used by the aovabasket website operated by {siteConfig.companyName}. Cookies are small files placed on a device by a website. Local storage is a similar browser feature that can retain information between visits.</p>

      <h2>Basket storage</h2>
      <p>We use a local-storage entry named “cartItems” to remember product identifiers, quantities and selected product options in your shopping basket. Without it, your basket would be lost when you refresh or leave the page.</p>

      <h2>Wishlist storage</h2>
      <p>We use a local-storage entry named “wishlist” to remember the product identifiers you choose to save. This feature is stored on your device and is not used to build an advertising profile.</p>

      <h2>Secure payment technologies</h2>
      <p>After you press “Pay”, you leave this website for the payment provider’s secure checkout. The payment provider may set strictly necessary cookies or use similar technologies for session management, authentication, security and fraud prevention. Those technologies are controlled by the payment provider and are covered by its own policy.</p>

      <h2>Analytics and advertising</h2>
      <p>The current aovabasket website does not set Google Analytics, Facebook Pixel or personalised-advertising cookies. We will update this policy and provide any consent controls required before introducing non-essential analytics or advertising technologies.</p>

      <h2>Managing stored information</h2>
      <p>You can remove aovabasket’s local storage through your browser’s site-data or privacy settings. You can also configure the browser to restrict cookies. Clearing local storage will remove the basket and wishlist saved on that device, and blocking essential payment cookies may prevent the external checkout from working correctly.</p>

      <h2>Changes and contact</h2>
      <p>We may update this policy if the website’s storage or payment technologies change. Questions can be sent to {siteConfig.email}, or by post to {siteConfig.companyName}, {siteConfig.address}.</p>
    </section>
  </main>;
}

export default Cookies;
